import { locationSearchFormStyles as styles } from "@tggstore/Overrides/Components/LocationSearchForm";
import { css } from "styled-components";

styles.distanceUnitOfMeasureRadioGroup = {
    ...styles.distanceUnitOfMeasureRadioGroup,
    css: css`
        ${styles.distanceUnitOfMeasureRadioGroup?.css}
        display: none;
    `,
};

styles.searchResultGoogleMapsDirectionLinkGridItem = {
    ...styles.searchResultGoogleMapsDirectionLinkGridItem,
    width: [9, 9, 9, 9, 6],
};

styles.searchResultDistanceGridItem = {
    ...styles.searchResultDistanceGridItem,
    width: [11, 11, 11, 11, 4],
};

styles.searchResultDividerGridItem = {
    ...styles.searchResultDividerGridItem,
    width: 12,
};

styles.searchResultEmailGridItem = {
    ...styles.searchResultEmailGridItem,
    width: 11,
};
